import { inject, Pipe, PipeTransform } from '@angular/core';
import { DateService } from '@pf/shared-services';

@Pipe({
    name: 'PfDate',
    standalone: false,
})
export class DatePipe implements PipeTransform {
    private dateService = inject(DateService);

    transform(
        value: string | Date | undefined | null,
        type: 'date' | 'time' | 'datetime' | 'elapsed' = 'datetime',
        timezone?: string,
        includeSeconds = false
    ): string {
        if (!value) {
            return '';
        }
        if (type === 'datetime') {
            return this.dateService.formatDateTime(
                value,
                timezone,
                includeSeconds
            );
        }
        if (type === 'date') {
            return this.dateService.formatDate(value);
        }
        if (type == 'time') {
            return this.dateService.formatTime(value, timezone, includeSeconds);
        }
        if (type === 'elapsed') {
            return this.dateService.timeElapsed(value);
        }
        return '';
    }
}
